
import { AnsweringClient } from "../../clients/answeringClient";
import { describeApiError, isExpiredSession } from "../../utils/apiError";

export interface ArchiveGroupModalControllerDelegate {
  didArchiveGroup: () => void;
  didFailArchiveGroup: (message: string) => void;
  groupShouldLogout: () => void;
}

export class ArchiveGroupModalController {

  constructor (
    private delegate: ArchiveGroupModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async archiveGroup(
    accessToken: string,
    groupId: string,
    alreadyRetried = false
  ): Promise<void> {
    try {
      await this.answeringClient.archiveGroup(accessToken, groupId);
      this.delegate.didArchiveGroup();
    } catch (error: any) {
      if (isExpiredSession(error) && !alreadyRetried) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        return this.archiveGroup(newTokens.accessToken, groupId, true);
      }
      this.delegate.didFailArchiveGroup(
        describeApiError(
          error,
          "Não foi possível arquivar o grupo. Tente novamente em instantes."
        )
      );
    }
  }

  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.groupShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.groupShouldLogout();
      return;
    }
  }
}
